import { renderComponentField } from "@easydev/form/FormField";
import PropTypes from "prop-types";
import React from "react";

export const FileInputField = React.forwardRef(
  (
    {
      onChange,
      name,
      value = null,
      multiple = false,
      accept = "video/*,image/*",
    },
    ref,
  ) => {
    const handleChange = (e) => {
      e.preventDefault();
      onChange(e.target.files);
    };

    return (
      <>
        <div className="form__form-group-files">
          <input
            value={
              typeof value !== "string"
                ? Array.from(value)
                    .map((file) => file.name.replace(/\.[^/\\]+$/, ""))
                    .join(" / ")
                : `${multiple ? "File's names" : "File name"}`
            }
            disabled
          />

          <label htmlFor={name}>Choose {multiple ? "files" : "file"}</label>
        </div>

        <input
          type="file"
          name={name}
          id={name}
          onChange={handleChange}
          ref={ref}
          multiple={multiple}
          className="form__form-group-files-input"
          accept={accept}
        />
      </>
    );
  },
);

FileInputField.propTypes = {
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.shape({
      name: PropTypes.string,
    }),
    PropTypes.string,
  ]),
};

export default renderComponentField(FileInputField);
